/**
 * Known tenant slugs that can be detected from URL paths
 */
export const KNOWN_TENANTS = ['homebody'] as const;

export type TenantSlug = typeof KNOWN_TENANTS[number] | null;

/**
 * Detects tenant from URL path
 * Examples:
 * - /chat → null (default tenant)
 * - /homebody → "homebody"
 * - /homebody/chat → "homebody"
 */
export function detectTenantFromPath(): TenantSlug {
  const path = window.location.pathname;
  const segments = path.split('/').filter(Boolean);
  
  // Check if first segment is a known tenant
  if (segments.length > 0 && KNOWN_TENANTS.includes(segments[0] as any)) {
    return segments[0] as TenantSlug;
  }
  
  return null; // Default tenant
}

/**
 * Returns the base path for the router based on detected tenant
 * Examples:
 * - null → ""
 * - "homebody" → "/homebody"
 */
export function getTenantBasePath(tenant: TenantSlug): string {
  return tenant ? `/${tenant}` : '';
}

/**
 * Returns the current route without the tenant prefix
 * Examples:
 * - /homebody/chat → /chat
 * - /chat → /chat
 */
export function getRouteWithoutTenant(path: string, tenant: TenantSlug): string {
  if (tenant) {
    return path.replace(`/${tenant}`, '') || '/';
  }
  return path;
}

